'use client';

import { c as _c } from "react/compiler-runtime";
import { RecentActivityItemLetter } from '../../molecules/recent-activity-item-letter/recent-activity-item-letter.tsx';
import { RecentActivityPanelSkeleton } from '../../molecules/recent-activity-panel/recent-activity-panel-skeleton.tsx';
import { RecentActivityPanel } from '../../molecules/recent-activity-panel/recent-activity-panel.tsx';
import { useComponentRecentActivityPanelLetters } from './recent-activity-panel-letters.logic.ts';
export const RecentActivityPanelLetters: React.FC = () => {
  const $ = _c(7);
  const {
    recentLetters,
    isError,
    isLoading,
    heading,
    subtitle,
    isShowingEmptyState
  } = useComponentRecentActivityPanelLetters();
  if (isLoading) {
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t0 = <RecentActivityPanelSkeleton />;
      $[0] = t0;
    } else {
      t0 = $[0];
    }
    return t0;
  }
  if (isError || isShowingEmptyState) {
    return null;
  }
  let t0;
  if ($[1] !== recentLetters) {
    t0 = recentLetters.map(_temp);
    $[1] = recentLetters;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  let t1;
  if ($[3] !== heading || $[4] !== subtitle || $[5] !== t0) {
    t1 = <div className="HomeDashboard__panel w-full"><RecentActivityPanel heading={heading} subheading={subtitle} items={t0} /></div>;
    $[3] = heading;
    $[4] = subtitle;
    $[5] = t0;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  return t1;
};
function _temp(letter) {
  return <RecentActivityItemLetter key={letter.id} letter={letter} />;
}